import { createMRTColumnHelper, MRT_ColumnDef } from "material-react-table";
import { UserEnum } from "../../types/userEnum";
import {
  EntityTableSuffixColumns,
  commonEntityFilterSpec,
} from "./EntityUtils";
import type { FilterSpec } from "../../hooks/useServerFilters";

const columnHelper = createMRTColumnHelper<UserEnum>();

const userEnumColumns: MRT_ColumnDef<UserEnum, any>[] = [
  columnHelper.accessor("name", {
    header: "Name",
  }),
  columnHelper.accessor("values", {
    header: "Values",
    Cell: ({ cell }) => {
      const values: string[] = cell
        .getValue<string[]>()
        .map((item) => item.trim())
        .filter((item) => item.length > 0);
      return values.length === 0 ? "-" : values.join(", ");
    },
  }),
  ...EntityTableSuffixColumns,
];

export const userEnumFilterSpec: FilterSpec = {
  name: { kind: "string" },
  values: { kind: "string" },
  ...commonEntityFilterSpec,
};

export default userEnumColumns;
